export default "__VITE_ASSET__Bk$rbhLR__"